// Client-side mirror of the backend admin RBAC (server is the source of truth).
export const ADMIN_SECTIONS = ["overview", "users", "demo", "broadcast", "feedback", "reports", "media", "market", "terms", "android", "ringtones", "cleanup"];
export const STAFF_ROLES = ["admin", "manager", "supervisor"];
const PRESETS = {
  admin: ADMIN_SECTIONS,
  manager: ["overview", "users", "broadcast", "feedback", "reports", "market", "terms"],
  supervisor: ["overview", "feedback", "reports"],
};

export function isStaff(user) {
  return !!user && (user.is_staff || STAFF_ROLES.includes(user.role));
}

export function allowedSections(user) {
  if (!user) return [];
  if (Array.isArray(user.admin_sections) && user.admin_sections.length) return user.admin_sections;
  if (user.role === "admin") return ADMIN_SECTIONS;
  if (Array.isArray(user.permissions) && user.permissions.length) return user.permissions;
  return PRESETS[user.role] || [];
}
